module.exports = __webpack_public_path__ + "static/kleinrusso-negativo-9223c41fc3d3d12e62d5f4362044fdd5.png";